



























































































































































import axios from 'axios';
import moment from 'moment-timezone';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import { baConfig } from '@/../config';
import { FiatType } from '@/api-svc-types';
import { BaseVue } from '@/BaseVue';
import CreateRateTableModal from '@/components/pricing/CreateRateTableModal.vue';
// Update 010425_3 importing the new modal component
import ImportRateTableModal from '@/components/pricing/ImportRateTableModal.vue';
import UiButton from '@/components/ui/UiButton.vue';
import UiDataTable from '@/components/ui/UiDataTable.vue';
import UiLoading from '@/components/ui/UiLoading.vue';
import UiPageHeader from '@/components/ui/UiPageHeader.vue';
import UiSelect2 from '@/components/ui/UiSelect2.vue';
import { RowAction, RowActionPlace, RowActionType } from '@/models/uiDataTable';
import { CancelablePromise, CanceledError, makeCancelable } from '@/utils/CancelablePromise';
import { getClusterAwareBaseUrl } from '@/utils/clusterAwareUrl';
import { getEndpointUrl } from '@/utils/endpointUrlUtil';
import numberUtils from '@/utils/numberUtils';

import { ApiSvcFiat } from '../../../generated/api-svc';
import { RateTable as RateTableType, RateTableEntry } from './types/rateTableTypes';

// Update 010425_3.2 declare the new modal component
@Component({
  components: {
    CreateRateTableModal,
    ImportRateTableModal,
    UiButton,
    UiSelect2,
    UiDataTable,
    UiLoading,
    UiPageHeader,
  },
})
export default class RateTable extends BaseVue {
  numberFormat = numberUtils.format;
  svcURL = getClusterAwareBaseUrl(baConfig.api2Url || '');
  selectedRateTableId: string | null = null;
  canCreateAndImport = false;
  isCreatingTable = false;
  // Update 010425_4 new variable to define when to open the import rates modal
  isImportingRate = false;
  isLoadingRateTables = false;
  isLoadingRates = 0;
  isExportingRates = false;
  isDeletingRows = false;
  displayDeletedRows = false;
  nextPageToken = 0;

  sort?: {
    field: string;
    order: 'asc' | 'desc';
  } = {
    field: '',
    order: 'desc',
  };

  readonly headers = [
    {
      id: 'startDate',
      label: this.$tc('_startDate') + ' (UTC)',
      defaultVisibility: true,
      // filterable: true,
      // sortable: true,
      // rangeFilter: true,
      type: 'date',
    },
    {
      id: 'endDate',
      label: this.$tc('_endDate') + ' (UTC)',
      defaultVisibility: true,
      // filterable: true,
      // sortable: true,
      // rangeFilter: true,
      type: 'date',
    },
    {
      id: 'ticker',
      label: 'From ' + this.$tc('_ticker', 2),
      defaultVisibility: true,
      // filterable: true,
      // sortable: true,
    },
    {
      id: 'toTickerCurrencyId',
      label: 'To ' + this.$tc('_ticker', 2),
      defaultVisibility: true,
      // filterable: true,
      // sortable: true,
    },
    {
      id: 'rate',
      label: this.$tc('_rate'),
      defaultVisibility: true,
      // filterable: true,
      // sortable: true,
    },
  ];

  selectedRowIds: string[] = [];
  selectableRowCallback = (rate: RateTableEntry) => !rate.deleted;

  readonly tableActions = [{ label: 'Show deleted rates', value: 'toggle_deleted' }];
  readonly selectedRowsActions: RowAction[] = [
    {
      label: 'Delete',
      value: this.deleteSelected,
      disabled: this.isDeletingRows,
      type: RowActionType.Button,
      place: [RowActionPlace.RowActions],
      sortIndex: 0,
    },
  ];

  rateTables: RateTableType[] = [];
  rateTableRates: RateTableEntry[] = [];
  previousPromise: CancelablePromise<any> | null = null;

  mounted() {
    this.canCreateAndImport =
      this.checkScope(this.scopeLiterals.PricingRulesCreate) && this.checkScope(this.scopeLiterals.PricingRulesUpdate);

    this.loadRateTables();
  }

  public get fiat() {
    const baseCurrency = this.$store.state.currentOrg.baseCurrency ?? 'USD';
    return (
      this.$store.getters['fiats/FIATS']?.find(
        (fiat: { name: string; symbol: string }) => fiat.name === baseCurrency
      ) ?? {
        name: baseCurrency,
        symbol: '$',
      }
    );
  }

  getFormattedDate(rawDate: string | number) {
    return moment.utc(rawDate).format('YYYY-MM-DD HH:mm:ss');
  }

  onSort(sort: { id: string; asc: boolean }) {
    this.sort = {
      field: sort.id,
      order: sort.asc ? 'asc' : 'desc',
    };

    // this.loadRateTableData();
  }

  onFilter(filter: any) {
    // this.loadRateTableDate();
  }

  onRateTableSelect(rateTableId: any) {
    if (rateTableId) {
      this.rateTableRates = [];
      this.loadRateTableData();
    }
  }

  onCopySuccess() {
    this.showSuccessSnackbar('Rate Table ID copied to clipboard');
  }

  onCopyError(e: any) {
    console.error('Failed to copy Rate Table ID:', e);
    this.showErrorSnackbar('Failed to copy Rate Table ID');
  }

  onRowSelectionChange(selections: RateTableEntry[]) {
    this.selectedRowIds = selections.map((r) => r.id);
  }

  public handleActionOnTable(handler: string | unknown) {
    if (typeof handler !== 'string') {
      (handler as () => void)();
    } else if (handler === 'toggle_deleted') {
      this.toggleDisplayDeletedRows();
    }
  }

  async afterCreate(data: { id?: string; failed?: boolean }) {
    this.isCreatingTable = false;
    if (data.id) {
      this.selectedRateTableId = data.id;
      this.rateTableRates = [];
      this.loadRateTableData();
    }
    if (!data.failed) await this.loadRateTables();
  }

  // Update 010425_5 Sets the values for importing rate appropriately to false after importing
  async afterImportRate(data: { failed?: boolean }) {
    this.isImportingRate = false;
    if (!data.failed) await this.loadRateTableData();
  }

  async loadRateTables() {
    this.isLoadingRateTables = true;

    try {
      const orgId = this.$store.state.currentOrg.id;
      const endpointURL = getEndpointUrl(this.svcURL, ['v2', 'orgs', orgId, 'rate-tables']);
      const resp = await axios.get<{ rateTables: RateTableType[] }>(endpointURL, {
        withCredentials: true,
      });

      this.isLoadingRateTables = false;

      if (resp.status === 200) {
        this.rateTables = (resp.data?.rateTables ?? []).sort((a, b) =>
          (a.name ?? '').localeCompare(b.name ?? '', undefined, { sensitivity: 'base' })
        );
      } else {
        this.showErrorSnackbar('Could not fetch rate tables');
      }
    } catch (error) {
      console.error(error);
      this.isLoadingRateTables = false;
      this.showErrorSnackbar('Unexpected error while loading rate tables');
    }
  }

  async loadRateTableData() {
    if (!this.selectedRateTableId) return;

    this.isLoadingRates++;
    this.nextPageToken = 0;

    try {
      this.previousPromise?.cancel();
      const originalPromise = this.getRateTableData(this.nextPageToken, false, !this.displayDeletedRows);
      const cancelablePromise = makeCancelable(originalPromise);
      this.previousPromise = cancelablePromise;
      this.rateTableRates = (await cancelablePromise) ?? [];
      this.isLoadingRates--;
    } catch (error) {
      this.isLoadingRates--;
      if (error instanceof CanceledError) {
        console.info('The get rate table data (rates) promise was cancled');
      } else {
        console.error(error);
        this.showErrorSnackbar('Unexpected error while loading rates');
      }
    }
  }

  async loadMoreRateTableData() {
    if (!this.selectedRateTableId || this.rateTableRates.length % 1000 !== 0) return;

    this.isLoadingRates++;

    try {
      this.previousPromise?.cancel();
      const originalPromise = this.getRateTableData(this.nextPageToken, false, !this.displayDeletedRows);
      const cancelablePromise = makeCancelable(originalPromise);
      this.previousPromise = cancelablePromise;

      this.rateTableRates = this.rateTableRates.concat((await cancelablePromise) ?? []);
      this.isLoadingRates--;
    } catch (error) {
      this.isLoadingRates--;
      if (error instanceof CanceledError) {
        console.info('The get rate table data (rates) promise was cancled');
      } else {
        console.error(error);
        this.showErrorSnackbar('Unexpected error while loading rates');
      }
    }
  }

  async exportRateTable() {
    if (this.isExportingRates) return;

    // Validate prerequisites
    if (!this.selectedRateTableId) {
      this.showErrorSnackbar('Please select a rate table to export.');
      return;
    }

    const orgId = this.$store.state.currentOrg.id;
    if (!orgId) {
      this.showErrorSnackbar('Organization ID not found.');
      return;
    }

    this.isExportingRates = true;

    try {
      const endpointURL = getEndpointUrl(this.svcURL, [
        'v2',
        'orgs',
        orgId,
        'rate-tables',
        this.selectedRateTableId,
        'export',
      ]);
      const resp = await axios.get<string>(endpointURL, {
        withCredentials: true,
      });

      if (resp.status === 200) {
        const csvData = resp.data;
        if (csvData) {
          this.downloadRatesCSV(csvData, 'text/csv', `${orgId}_${this.selectedRateTableId}_rates.csv`);
        } else {
          this.showErrorSnackbar('Export failed: No CSV data received from server.');
        }
      } else {
        this.showErrorSnackbar(`Export failed with status: ${resp.status}`);
      }
    } catch (error) {
      this.showErrorSnackbar('Unexpected error while exporting rate table.');
    } finally {
      this.isExportingRates = false;
    }
  }

  private async getRateTableData(startPage?: number, getAllData?: boolean, displayDeletedRows?: boolean) {
    if (startPage !== undefined && startPage < 0) return [];

    let rateTableRates: RateTableEntry[] = [];

    const orgId = this.$store.state.currentOrg.id;
    let nextPageToken = startPage ?? 0;
    let lastBatch = false;

    do {
      const endpointURL = getEndpointUrl(
        this.svcURL,
        ['v2', 'orgs', orgId, 'rate-tables', this.selectedRateTableId, 'paginated'],
        {
          page: nextPageToken,
        }
      );
      const resp = await axios.get<{ rates: RateTableEntry[]; nextPageToken: number }>(endpointURL, {
        withCredentials: true,
      });

      if (resp.status === 200) {
        rateTableRates = rateTableRates.concat(resp.data?.rates ?? []);
        nextPageToken = resp.data?.nextPageToken;
      } else {
        this.showErrorSnackbar('Could not fetch rates!');
        return undefined;
      }

      if (!getAllData) {
        this.nextPageToken++;
      }

      // Continue if we got a full batch (1000 items) AND getAllData is true
      lastBatch = (resp.data?.rates?.length ?? 0) < 1000 || !getAllData;
    } while (!lastBatch);

    if (displayDeletedRows) {
      rateTableRates = rateTableRates.filter((rate) => !rate.deleted);
    }

    return rateTableRates;
  }

  private toggleDisplayDeletedRows() {
    this.displayDeletedRows = !this.displayDeletedRows;
    this.loadRateTableData();

    // The timeout keeps the action label unchanged long enough for the actions dropdown to close
    setTimeout(() => {
      const toggleAction = this.tableActions.find((action) => action.value === 'toggle_deleted');
      if (toggleAction) toggleAction.label = this.displayDeletedRows ? 'Hide deleted rate' : 'Show deleted rates';
    }, 100);
  }

  private async deleteSelected() {
    if (this.isDeletingRows || !this.selectedRowIds?.length) return;

    this.isDeletingRows = true;

    try {
      const orgId = this.$store.state.currentOrg.id;
      const endpointURL = getEndpointUrl(this.svcURL, [
        'v2',
        'orgs',
        orgId,
        'rate-tables',
        this.selectedRateTableId,
        'rows',
      ]);
      const resp = await axios.delete(endpointURL, {
        withCredentials: true,
        data: {
          rowIds: this.selectedRowIds,
        },
      });
      this.isDeletingRows = false;

      if (resp.status === 200) {
        this.showSuccessSnackbar(`Successfully deleted ${this.selectedRowIds.length} rates`);
        this.loadRateTableData();
      } else {
        this.showErrorSnackbar('Could not delete rates');
      }
    } catch (error) {
      console.error(error);
      this.isDeletingRows = false;
      this.showErrorSnackbar('Unexpected error while deleting rates');
    }
  }

  private downloadRatesCSV(data: string, type: string, filename: string) {
    const blob = new Blob([data], { type });
    console.log(blob);
    const link = document.createElement('a');
    const url = window.URL.createObjectURL(blob);
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  @Watch('$store.state.currentOrg.id')
  onOrgChange() {
    if (this.rateTables) {
      this.selectedRateTableId = null;
      this.rateTables = [];
      this.rateTableRates = [];
      this.loadRateTables();
    }
  }

  public formatFiatCurrency(currency?: string): string {
    if (!currency) {
      // Fall back to org's base currency
      currency = this.$store.state.currentOrg.baseCurrency;
      if (!currency) return '$';
    }

    if (currency.startsWith('COIN')) return currency;

    if (!currency.startsWith('FIAT') && currency.split('.').length !== 2) {
      return '';
    }

    // At this point we know currency is defined since we handled the null case above
    const currencyValue = parseInt(currency.split('.')[1]) as ApiSvcFiat;
    const fiats = this.$store.state.fiats.fiats as FiatType[] | undefined;
    const fiat = fiats?.find((f) => f.id === currencyValue.toString());
    return fiat?.name || currencyValue.toString();
  }
}
